const handlePromise = ( promise: Promise<any> ) => promise
  .then( ( response ) => {
    if ( response.ok ) return ( [null, response, response.data] );
    return ( [response.errors, response, null] );
  } )
  .catch( ( error ) => Promise.resolve( [error, { ok: false }, null] ) );

export default handlePromise;
